var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('h2',{staticClass:"section-title__wrapper"},[_c('a-link',{attrs:{"to":_vm.to}},[_vm._t("default")],2)],1):_c('h2',{staticClass:"section-title__wrapper"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }